import type { ApiProblem } from "@learn-flow/contracts";

export class ApiError extends Error {
  public constructor(
    public readonly status: number,
    public readonly problem: ApiProblem | null,
  ) {
    super(problem?.title ?? "The request could not be completed.");
  }
}

let apiOrigin = "";

export function configureApiOrigin(origin: string): void {
  apiOrigin = new URL(origin).origin;
}

export async function apiRequest<T>(path: string, init?: RequestInit): Promise<T> {
  const headers = new Headers(init?.headers);
  if (init?.body !== undefined) headers.set("Content-Type", "application/json");

  const response = await fetch(`${apiOrigin}${path}`, {
    ...init,
    headers,
    credentials: apiOrigin ? "include" : "same-origin",
  });

  if (!response.ok) {
    let problem: ApiProblem | null = null;
    try {
      problem = (await response.json()) as ApiProblem;
    } catch {
      // A safe fallback message is provided by ApiError.
    }
    throw new ApiError(response.status, problem);
  }

  if (response.status === 204) return undefined as T;
  return (await response.json()) as T;
}
